import { render } from "./InvoiceCustomers.vue?vue&type=template&id=954b7488"
import script from "./InvoiceCustomers.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__